import { buildQuery } from '@cwp/utils'

function buildAdvisorSearchCrit(options) {
  const { search, zip } = options
  const criteria = {
    al: 0,
    aof: '',
    d: '',
    li: false,
    nrr: 10,
    rd: 0,
    se: '',
    sri: 0,
    st: zip ? 'zip code' : 'city, state',
    t: search || zip
  }

  return Object.keys(criteria)
    .map(key => `${key}:${criteria[key]}`)
    .join(';')
}

export function getAdvisorSearchUrl(options = {}) {
  const query = buildQuery({
    crit: `{${buildAdvisorSearchCrit(options)}}`,
    old: true,
    page: 0,
    view: 'list'
  })

  // return url with custom query param
  return `${window.AMERIPRISE_ADVISORS_SITE_URL}/#search?${query}`
}
